import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LOGO_CIVISOFT, LOGO_GEO5 } from "../constants";
import { GEO5_MODULES } from "../kb/geo5Modules";

function PageAccueil({ onEnter, onLogout, licence }) {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(null);

  const GV = {
    vert:      "#2D7A2D",
    vertClair: "#00A651",
    vertLight: "#E8F5E9",
    vertMid:   "#4CAF50",
    vertDark:  "#1B5E20",
    blanc:     "#FFFFFF",
    gris:      "#F5F5F5",
    grisMid:   "#757575",
    dark:      "#1A1A1A",
    border:    "#E0E0E0",
  };

  const FONCTIONNALITES_ICONES = ["🤖","🧭","⚖️","📋"];
  const FONCTIONNALITES = (t("pageaccueil.fonctionnalites", { returnObjects: true }) || []).map((f, i) => ({
    icone: FONCTIONNALITES_ICONES[i], titre: f.titre, desc: f.desc,
  }));

  const MODULES_ICONES  = ["⛰️","💧","🏢","⚓","🔩","📉","🧱","🏰","🪨","↔️","🏛️","📐","📌","🪨"];
  const MODULES_COULEURS = ["#2D7A2D","#0369a1","#1565C0","#00838F","#4527A0","#C62828","#E65100","#6A1B9A","#16a34a","#b45309","#475569","#0891b2","#7c3aed","#57534e"];
  const MODULES = (t("pageaccueil.modules", { returnObjects: true }) || []).map((nom, i) => ({
    icone: MODULES_ICONES[i], nom, couleur: MODULES_COULEURS[i],
  }));

  return (
    <div style={{ fontFamily:"'Segoe UI', system-ui, sans-serif", background:GV.blanc, minHeight:"100vh" }}>

      {/* ══ HEADER ══ */}
      <header style={{
        background:GV.blanc,
        borderBottom:`3px solid ${GV.vert}`,
        padding:"0 48px",
        boxShadow:"0 2px 8px rgba(0,0,0,0.08)"
      }}>
        {/* Barre supérieure */}
        <div style={{
          display:"flex", alignItems:"center", justifyContent:"space-between",
          padding:"12px 0", borderBottom:`1px solid ${GV.border}`
        }}>
          {/* Logo Civisoft */}
          <img src={LOGO_CIVISOFT} alt="CiviSoft" style={{ height:52, objectFit:"contain" }}/>

          {/* Logo GeoExpert central */}
          <div style={{ textAlign:"center" }}>
            <img
              src="/assets/logo_geoexpert.png"
              alt="GeoExpert"
              style={{ height:60, objectFit:"contain" }}
            />
          </div>

          {/* Logo GEO5 + Déconnexion */}
          <div style={{ display:"flex", alignItems:"center", gap:16 }}>
            <img src={LOGO_GEO5} alt="GEO5 Authorized Partner" style={{ height:44, objectFit:"contain" }}/>
            {onLogout && (
              <>
                <div style={{ width:1, height:28, background:GV.border }}/>
                <button
                  onClick={onLogout}
                  style={{ background:"transparent", border:`1px solid rgba(0,0,0,0.18)`, color:"#666", fontSize:12, padding:"6px 14px", borderRadius:6, cursor:"pointer" }}
                >
                  Déconnexion
                </button>
              </>
            )}
          </div>
        </div>

        {/* Nav verte supprimée */}
      </header>

      {/* ══ HERO SECTION ══ */}
      <section style={{
        position:"relative", overflow:"hidden",
        background:`linear-gradient(135deg, ${GV.vertDark} 0%, ${GV.vert} 40%, ${GV.vertClair} 100%)`,
        minHeight:480, display:"flex", alignItems:"center"
      }}>
        {/* Formes géométriques fond — style Fine */}
        <div style={{
          position:"absolute", right:0, top:0, bottom:0, width:"45%",
          background:`linear-gradient(135deg, ${GV.vertClair}90, ${GV.vertMid}60)`,
          clipPath:"polygon(15% 0, 100% 0, 100% 100%, 0% 100%)"
        }}/>
        <div style={{
          position:"absolute", right:"5%", top:"10%",
          width:120, height:120,
          background:`${GV.vertMid}40`,
          transform:"rotate(45deg)"
        }}/>
        <div style={{
          position:"absolute", right:"20%", bottom:"10%",
          width:80, height:80,
          background:`${GV.blanc}15`,
          transform:"rotate(45deg)"
        }}/>

        {/* Contenu hero */}
        <div style={{ position:"relative", zIndex:2, padding:"60px 48px", maxWidth:680 }}>
          <div style={{
            display:"inline-flex", alignItems:"center", gap:8,
            background:"rgba(255,255,255,0.15)", borderRadius:99,
            padding:"6px 16px", marginBottom:20
          }}>
            <span style={{ width:8, height:8, borderRadius:"50%", background:"#7FFF00", display:"inline-block" }}/>
            <span style={{ color:GV.blanc, fontSize:12, fontWeight:600, letterSpacing:1 }}>{t("pageaccueil.badge")}</span>
          </div>

          <h1 style={{ color:GV.blanc, fontSize:42, fontWeight:900, margin:"0 0 16px", lineHeight:1.15 }}>
            GEO5<br/>
            <span style={{ fontWeight:400, fontSize:32 }}>Expert Advisor</span>
          </h1>

          <p style={{ color:"rgba(255,255,255,0.88)", fontSize:17, lineHeight:1.7, margin:"0 0 32px", maxWidth:520 }}>
            {t("pageaccueil.hero_p")}
          </p>

          <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
            <button onClick={() => onEnter("projet")}
              style={{
                background:GV.blanc, color:GV.vert,
                border:"none", borderRadius:8,
                padding:"14px 32px", fontSize:15, fontWeight:800,
                cursor:"pointer",
                boxShadow:"0 4px 20px rgba(0,0,0,0.2)",
                transition:"all 0.2s"
              }}
              onMouseEnter={e => { e.currentTarget.style.background = GV.gris; }}
              onMouseLeave={e => { e.currentTarget.style.background = GV.blanc; }}
            >
              {t("pageaccueil.btn_demarrer")}
            </button>
          </div>
        </div>

        {/* Stats hero droite */}
        <div style={{
          position:"absolute", right:"48px", top:"50%",
          transform:"translateY(-50%)", zIndex:3,
          display:"flex", flexDirection:"column", gap:16
        }}>
          {[
            { val:"24",      label: t("pageaccueil.stats.modules") },
            { val: licence === "dz" ? "RPA 2024" : "NF EN 1998", label: licence === "dz" ? t("pageaccueil.stats.norme_sismique") : "EC8 (Eurocode 8)" },
            { val:"EC7",     label: licence === "fr" ? "NF EN 1997 / NF P 94" : "Eurocode 7" },
            { val: licence === "eu" ? "AI" : "IA", label: t("pageaccueil.stats.agent") },
          ].map((s, i) => (
            <div key={i} style={{
              background:"rgba(255,255,255,0.12)",
              backdropFilter:"blur(8px)",
              border:"1px solid rgba(255,255,255,0.2)",
              borderRadius:10, padding:"12px 20px", textAlign:"center",
              minWidth:120
            }}>
              <div style={{ fontSize:22, fontWeight:900, color:GV.blanc }}>{s.val}</div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,0.75)", marginTop:2 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ══ WORKFLOW — Enchainement logique du projet ══ */}
      <section style={{ padding:"56px 48px", background:GV.gris, borderTop:`1px solid ${GV.border}` }}>
        <div style={{ textAlign:"center", marginBottom:40 }}>
          <div style={{ fontSize:12, color:GV.vertClair, fontWeight:700, letterSpacing:3, textTransform:"uppercase", marginBottom:8 }}>
            {t("pageaccueil.workflow_label")}
          </div>
          <h2 style={{ fontSize:28, fontWeight:800, color:GV.dark, margin:"0 0 8px" }}>
            {t("pageaccueil.workflow_titre")}
          </h2>
          <p style={{ fontSize:14, color:GV.grisMid, margin:0 }}>
            {t("pageaccueil.workflow_hint")}
          </p>
        </div>

        {/* Étapes du workflow */}
        <div style={{ maxWidth:1200, margin:"0 auto" }}>
          {/* Conteneur flex horizontal avec flèches */}
          <div style={{ display:"flex", alignItems:"stretch", gap:0, overflowX:"auto" }}>
            {(t("pageaccueil.workflow_etapes", { returnObjects: true }) || []).map((etape, i, arr) => {
              const ICONES = ["🚀","🌍","⚠️","📋","🤖","⚖️","🧭"];
              return (
              <div key={i} style={{ display:"flex", alignItems:"stretch", flex:1, minWidth:0 }}>
                {/* Carte étape — visuelle uniquement */}
                <div
                  style={{
                    flex:1, background:GV.blanc, border:`1.5px solid ${GV.border}`,
                    borderRadius:12, padding:"20px 16px", cursor:"default",
                    boxShadow:"0 2px 8px rgba(0,0,0,0.05)",
                    display:"flex", flexDirection:"column", alignItems:"center", textAlign:"center", gap:8
                  }}>
                  {/* Numéro */}
                  <div className="etape-num" style={{ width:28, height:28, borderRadius:"50%", background:GV.vertLight, color:GV.vert, fontSize:12, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.22s" }}>{i + 1}</div>
                  {/* Icone */}
                  <div style={{ fontSize:28 }}>{ICONES[i]}</div>
                  {/* Label */}
                  <div className="etape-titre" style={{ fontSize:13, fontWeight:800, color:GV.dark, transition:"all 0.22s" }}>{etape.label}</div>
                  {/* Description */}
                  <div className="etape-desc" style={{ fontSize:11, color:GV.grisMid, lineHeight:1.5, transition:"all 0.22s" }}>{etape.desc}</div>
                </div>
                {/* Flèche entre étapes */}
                {i < arr.length - 1 && (
                  <div style={{ display:"flex", alignItems:"center", padding:"0 6px", color:GV.vertMid, fontSize:18, fontWeight:900, flexShrink:0 }}>›</div>
                )}
              </div>
            );})}
          </div>

        </div>
      </section>

      {/* ══ FONCTIONNALITÉS ══ */}
      <section style={{ padding:"56px 48px", background:GV.blanc }}>
        <div style={{ textAlign:"center", marginBottom:40 }}>
          <div style={{ fontSize:12, color:GV.vertClair, fontWeight:700, letterSpacing:3, textTransform:"uppercase", marginBottom:8 }}>
            {t("pageaccueil.features_label")}
          </div>
          <h2 style={{ fontSize:28, fontWeight:800, color:GV.dark, margin:0 }}>
            {t("pageaccueil.features_titre")}
          </h2>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:24, maxWidth:1200, margin:"0 auto" }}>
          {FONCTIONNALITES.map((f, i) => (
            <div key={i}
              style={{
                background:GV.blanc, border:`1px solid ${GV.border}`,
                borderRadius:14, padding:"28px 24px",
                cursor:"default", transition:"all 0.25s",
                boxShadow:"0 2px 12px rgba(0,0,0,0.07)",
                borderTop:`4px solid ${GV.vert}`
              }}>
              <div style={{ fontSize:36, marginBottom:14 }}>{f.icone}</div>
              <div style={{ fontSize:15, fontWeight:800, color:GV.dark, marginBottom:10 }}>{f.titre}</div>
              <div style={{ fontSize:13, color:GV.grisMid, lineHeight:1.7 }}>{f.desc}</div>
              <div style={{ marginTop:16, color:"#C0C0C0", fontSize:12, fontStyle:"italic" }}>{t("pageaccueil.features_inclus")}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ══ MODULES GEO5 ══ */}
      <section style={{ padding:"48px 48px", background:GV.gris }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:32 }}>
            <div style={{ fontSize:12, color:GV.vertClair, fontWeight:700, letterSpacing:3, textTransform:"uppercase", marginBottom:8 }}>
              {t("pageaccueil.kb_label")}
            </div>
            <h2 style={{ fontSize:26, fontWeight:800, color:GV.dark, margin:0 }}>
              {t("pageaccueil.kb_titre")}
            </h2>
          </div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:12, justifyContent:"center" }}>
            {MODULES.map((m, i) => (
              <div key={i} style={{
                background:GV.blanc, border:`1.5px solid ${m.couleur}30`,
                borderRadius:10, padding:"12px 18px",
                display:"flex", alignItems:"center", gap:10,
                boxShadow:"0 1px 6px rgba(0,0,0,0.06)"
              }}>
                <span style={{ fontSize:22 }}>{m.icone}</span>
                <span style={{ fontSize:13, fontWeight:700, color:GV.dark }}>{m.nom}</span>
                <span style={{ width:8, height:8, borderRadius:"50%", background:m.couleur, flexShrink:0 }}/>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA final supprimé */}

      {/* ══ FOOTER ══ */}
      <footer style={{ background:"#1a1a1a", color:"rgba(255,255,255,0.5)", padding:"24px 48px", textAlign:"center", fontSize:12 }}>
        <div style={{ marginBottom:8 }}>
          <img src="/assets/logo_geoexpert.png" alt="GeoExpert" style={{ height:32, objectFit:"contain", opacity:0.65 }}/>
        </div>
        <div style={{ fontWeight:600, color:"rgba(255,255,255,0.75)", marginBottom:4 }}>GeoExpert FR — Civisoft</div>
        <div style={{ marginBottom:4 }}>Distributeur agréé GEO5 — France</div>
        <div style={{ marginBottom:8 }}>contact@civisoft-fr.com</div>
        <div>© 2026 Civisoft — Tous droits réservés</div>
      </footer>
    </div>
  );
}





// =============================================================================
// SYSTÈME DE PROFIL UTILISATEUR
// Popup premier lancement → infos identité → GEO5 oui/non → modules possédés
// =============================================================================

const CIVISOFT_CONTACT = {
  nom: "Civisoft France",
  adresse: "Partenaire Autorisé GEO5 en France",
  email: "contact@civisoft.fr",
  web: "https://civisoft.fr",
};

// Modules GEO5 supportés par l'IA — organisés par catégorie

export default PageAccueil;
